const brokers = state => state.rebate.brokers;

export default {
  brokers,
};
